export default __webpack_public_path__ + "static/SRUS P193L4 - Product Specifications & Technical Data-441e15f1d3214a5cc8da75b8442eb308.pdf";